/*
 * Test to see if passed arg is an array and it has elements
 * */
type NonEmptyArray<T> = readonly [T, ...ReadonlyArray<T>];
export const isValidNonEmptyArray = <T>(arr: ReadonlyArray<T> | undefined): arr is NonEmptyArray<T> => Array.isArray(arr) && arr.length > 0;
export const isValidFilteredEmptyArray = <T>(arr: ReadonlyArray<T> | undefined): arr is NonEmptyArray<T> =>
  Array.isArray(arr) && arr.filter(Boolean).length > 0;
